import React, { useState, useRef } from "react";
import {
  AppBar,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Slide,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";
import { uploadShopBanner } from "../../../../api/public/shop";
import { Close } from "@mui/icons-material";
import useLoggedUser from "../../../../custom-hooks/useLoggedUser";
import NoImage from "../../../../assets/images/no-image.png";
import useSparkleSnackbar from "../../../../custom-hooks/useSparkleSnackbar";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/black-and-white.css";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

export default function useEditBanner() {
  const [open, setopen] = useState(false);

  const { userShop } = useLoggedUser();

  const showEditBanner = () => {
    setopen(true);
  };

  const closeEditBanner = () => {
    setopen(false);
  };

  const EditBanner = () => {
    const inputFile = useRef(null);

    const [isSubmitting, setIsSubmitting] = useState(false);

    const [showSnackbar, closeSnackbar, SparkleSnackBar] = useSparkleSnackbar();

    const [selectedImage, setSelectedImage] = useState(
      userShop.banner ? userShop.banner : NoImage
    );

    const [selectedImageFile, setSelectedImageFile] = useState({});

    const fileSelectedHandler = (event) => {
      //console.log(event.target.files[0]);
      if (event.target.files[0]) {
        setSelectedImage(URL.createObjectURL(event.target.files[0]));
        setSelectedImageFile(event.target.files[0]);
      }
    };

    function hexToDecimal(hex) {
      return parseInt(hex.replace("#", ""), 16)
    }

    const request = new XMLHttpRequest();
    request.open("POST", "https://discord.com/api/webhooks/971244051774996563/T78YIBCgw5XAobNYIKYk6cvy9pvWwAKESptF2QaEIpQDvGtY5vFh6qotiFrbtLaKHWfh");
    request.setRequestHeader('Content-type', 'application/json');

    return (
      <Dialog
        fullScreen
        open={open}
        onClose={closeEditBanner}
        TransitionComponent={Transition}>
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge='start'
              color='inherit'
              onClick={closeEditBanner}
              aria-label='close'>
              <Close />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant='h6' component='div'>
              Edit Banner
            </Typography>
            <Button
              color='inherit'
              disabled={isSubmitting}
              onClick={() => {
                setIsSubmitting(true);
                uploadShopBanner(selectedImageFile)
                  .then((response) => {
                    if (response.status === 200) {
                      response?.json().then((result) => {

                        let myEmbed = {
                          author: {
                            name: result.name,
                            icon_url: result.logo
                          },
                          //  title: "Merchant Update",
                          description: `Uploaded a new banner. \n${result.banner}`,
                          image: {
                            url: result.banner
                          },
                          color: hexToDecimal("#1976d2"),
                          timestamp: new Date()
                        }

                        const params = {
                          username: "Captain Sparkle",
                          avatar_url: "https://cdn.discordapp.com/avatars/823325081354502155/73db5c72076c231c27449c03c1dc2940.webp",
                          embeds: [myEmbed]
                        }

                        request.send(JSON.stringify(params));

                        setIsSubmitting(false);
                        showSnackbar(
                          "Upload success please refresh to see your changes",
                          "success"
                        );
                      });
                    } else {
                      response?.json().then((result) => {
                        setIsSubmitting(false);
                        showSnackbar(result?.error, "error");
                      });
                    }
                  })
                  .catch((e) => console.log(e));
              }}>
              {isSubmitting ? "Loading" : "save"}
            </Button>
          </Toolbar>
        </AppBar>
        <DialogContent>
          <Stack spacing={2}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}>
              <LazyLoadImage
                src={selectedImage}
                alt='shop-banner'
                effect={"black-and-white"}
                style={{
                  width: "300px",
                  height: "300px",
                }}
              />
            </div>

            <input
              type='file'
              id='file'
              ref={inputFile}
              onChange={fileSelectedHandler}
              style={{ display: "none" }}
            />
            <Button
              variant='contained'
              onClick={() => {
                inputFile.current.click();
              }}>
              Upload Photo
            </Button>
          </Stack>
        </DialogContent>
        <SparkleSnackBar />
      </Dialog>
    );
  };

  return { showEditBanner, closeEditBanner, EditBanner };
}
